import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import PanelLayout from "../components/PanelLayout";
import PanelAdsHeader from "../components/PanelAdsHeader";
import { ListSkeleton } from "../components/Skeleton";
import * as actions from "../redux/actions/indicatorActions";
import "./styles/PanelIndicators.css";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

const PERIODS = [
  { key: "week", label: "indicator_week" },
  { key: "month", label: "indicator_month" },
  { key: "year", label: "indicator_year" },
];

const BARS = [
  { key: "Sales", label: "sales", color: "#2f80ed" },
  { key: "Rents", label: "rents", color: "#27ae60" },
  { key: "Exchanges", label: "exchanges", color: "#f2994a" },
  { key: "Donations", label: "donations", color: "#eb5757" },
  { key: "Auctions", label: "auction", color: "#9b51e0" },
];

class PanelIndicators extends React.Component {
  state = {
    period: "month",
  };

  componentDidMount() {
    this.fetchIndicators(this.state.period);
  }

  fetchIndicators = async (period) => {
    const { user_id, token } = this.props;
    if (!user_id || !token) return;

    const result = await this.props.LoadIndicators(user_id, token, period);
    if (result && !result.ok) {
      alertify.warning(I18n.t(result.error || "try_later"));
    }
  };

  onSelectPeriod = (period) => () => {
    if (period === this.state.period) return;
    this.setState({ period });
    this.fetchIndicators(period);
  };

  render() {
    const { item, loading } = this.props;
    const values = BARS.map((bar) => Number(item[bar.key]) || 0);
    const max = Math.max(...values, 1);
    const total = values.reduce((acc, value) => acc + value, 0);

    return (
      <PanelLayout>
        <div className="panel-indicators-page">
          <PanelAdsHeader
            title={<Translate value="indicator_title" />}
            subtitle={<Translate value="indicator_subtitle" />}
          />

          <div className="indicator-filters">
            {PERIODS.map((period) => (
              <button
                key={period.key}
                type="button"
                className={
                  "indicator-filter" +
                  (this.state.period === period.key
                    ? " indicator-filter--active"
                    : "")
                }
                onClick={this.onSelectPeriod(period.key)}
              >
                <Translate value={period.label} />
              </button>
            ))}
          </div>

          <div className="indicator-card">
            <div className="indicator-card__head">
              <span className="indicator-card__total-label">
                <Translate value="indicator_total" />
              </span>
              <span className="indicator-card__total-value">{total}</span>
            </div>

            {loading ? (
              <ListSkeleton />
            ) : (
              <div className="indicator-chart">
                {BARS.map((bar) => {
                  const value = Number(item[bar.key]) || 0;
                  const height = Math.round((value / max) * 100);
                  return (
                    <div className="indicator-bar" key={bar.key}>
                      <span className="indicator-bar__value">{value}</span>
                      <div className="indicator-bar__track">
                        <div
                          className="indicator-bar__fill"
                          style={{
                            height: value > 0 ? `${Math.max(height, 4)}%` : "2px",
                            background: bar.color,
                          }}
                        />
                      </div>
                      <span className="indicator-bar__label">
                        <Translate value={bar.label} />
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    item: reducer.indicator.item,
    loading: reducer.indicator.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadIndicators: (user_id, token, period) =>
    dispatch(actions.loadList({ user_id, token, period })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelIndicators);
